import 'core-js/stable';
import 'regenerator-runtime/runtime';
import { createApp } from 'vue';
import AppVue from './App.vue';
import router from './router';
import store from './store';
import Antd, { message } from 'ant-design-vue/dist/antd.js';
import 'ant-design-vue/dist/antd.css';
import './style/index.scss';
import {GET, POST, PUT, DELETE } from '@/packge/http';
import Common from '@/utils/common';
import 'vant/lib/toast/style';
import { Toast } from 'vant';

const App = createApp(AppVue);
App.config.globalProperties.$get = GET.bind({});
App.config.globalProperties.$post = POST.bind({});
App.config.globalProperties.$put = PUT.bind({});
App.config.globalProperties.$delete = DELETE.bind({});

let config = { baseURL: process.env.VUE_APP_BASE_API_LOGIN };
App.config.globalProperties._get = GET.bind(config);
App.config.globalProperties._post = POST.bind(config);
App.config.globalProperties._put = PUT.bind(config);
App.config.globalProperties._delete = DELETE.bind(config);

for (let item in Common) {
  App.config.globalProperties[item] = Common[item];
}

message.config({ maxCount: 1 });

App.use(store).use(router).use(Antd).use(Toast).mount('#app');
